export default __webpack_public_path__ + "5226cdbbb2c41449ea008e7964b34541.png";